import React, { useContext } from 'react'

import { Layout, Menu } from 'antd';
import { LoginOutlined, TeamOutlined, UploadOutlined } from '@ant-design/icons';
import { BrowserRouter, Link, Navigate, Route, Routes } from 'react-router-dom';

import Login from './Login';
import Tail from './Tail';
import NewTicket from './NewTicket';
import Desktop from './Desktop';
import { UIContext } from '../context/UIContext';

const { Content, Sider } = Layout;

const RouterPage = () => {

    const { hiddenMenu } = useContext(UIContext)

    return (
        <BrowserRouter>
            <Layout style={{ 'height': '100vh' }}>
                <Sider
                    hidden={ hiddenMenu }
                    breakpoint="lg"
                    collapsedWidth="0"
                    onBreakpoint={(broken) => {
                        console.log(broken);
                    }}
                    onCollapse={(collapsed, type) => {
                        console.log(collapsed, type);
                    }}
                >
                    <div className="logo" />
                    <Menu
                        theme="dark"
                        mode="inline"
                        defaultSelectedKeys={['1']}
                        items={[
                            {
                                text: 'Login',
                                icon: LoginOutlined,
                                path: '/login'
                            },
                            {
                                text: 'Tail',
                                icon: TeamOutlined,
                                path: '/tail'
                            },
                            {
                                text: 'New ticket',
                                icon: UploadOutlined,
                                path: '/new_ticket'
                            }
                        ].map((item, index) => ({
                            key: String(index + 1),
                            icon: React.createElement(item.icon),
                            label: <Link to={item.path}>{ item.text }</Link>,
                        }),
                        )}
                    />
                </Sider>
                <Layout>
                    <Content
                        style={{
                            margin: '24px 16px 0',
                        }}
                    >
                        <div
                            className="site-layout-background"
                            style={{
                                padding: 24,
                                minHeight: 360,
                            }}
                        >
                            <Routes>
                                <Route path='/login' element={ <Login /> } />
                                <Route path='/tail' element={ <Tail /> } />
                                <Route path='/new_ticket' element={ <NewTicket /> } />
                                <Route path='/desktop' element={ <Desktop /> } />

                                <Route path='*' element={ <Navigate to="/login" /> } />
                            </Routes>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </BrowserRouter>
    )
}

export default RouterPage